import styled from 'styled-components'

export const SwitchLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
`

export const HiddenInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`

export const Track = styled.span`
  position: relative;
  width: 44px;
  height: 24px;
  border-radius: 12px;
  background: ${({ $checked }) => ($checked ? 'var(--color-brand-live)' : 'var(--vo-capri-25)')};
  border: 1px solid ${({ $checked }) => ($checked ? 'var(--color-brand-live)' : 'var(--vo-cloud)')};
  transition: background 0.2s, border-color 0.2s;
  flex-shrink: 0;
`

export const Thumb = styled.span`
  position: absolute;
  top: 2px;
  left: ${({ $checked }) => ($checked ? '22px' : '2px')};
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: left 0.2s;
`

export const LabelText = styled.span`
  font-size: 14px;
  color: var(--vo-ink);
`
